import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'

export const deleteMinimumOrder = (minOrderId: string): Promise<any> => {
  return axios.delete(`/parameters/min-order-per-product-group/${minOrderId}`)
}

export function useDeleteMinimumOrder() {
  const queryClient = useQueryClient()

  return useMutation(deleteMinimumOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries('minimumOrdersByProductGroup')
      toast.success('Pedido mínimo por grupo de produto excluído com sucesso!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error(
        'Não foi possível excluir pedido mínimo por grupo de produto!'
      )
    }
  })
}
